<template>
  <div>
    <v-row v-if="!regDataIsComplte">
      <div class="d-flex justify-space-between">
        <div>
          <span class="font-weight-black"> وضعیت ثبت اطلاعات&nbsp</span>
          <span class="mr-2"
            >اطلاعات ثبتی هنوز کامل نشده است و قابل ارسال جهت انتشار
            نمی‌باشد</span
          >
          <span class="mr-2">لطفاً موارد مشخص شده را تکمیل نمایید.</span>
        </div>
        <HelperComponent helperId="business-registration-complte-info" />
      </div>

      <!-- <v-card width="100%">
        <v-card-title>وضعیت ثبت اطلاعات کسب و کار</v-card-title> -->
      <v-stepper
        width="100%"
        vertical
        :height="$vuetify.breakpoint.smAndDown ? '200' : '65'"
      >
        <v-stepper-header>
          <v-stepper-step
            :rules="[() => regStatus.step1]"
            step="1"
            :complete="regStatus.step1"
          >
            اطلاعات مدیریتی
          </v-stepper-step>

          <v-divider></v-divider>
          <v-stepper-step
            :rules="[() => regStatus.step2]"
            step="2"
            :complete="regStatus.step2"
          >
            اطلاعات حقوقی
          </v-stepper-step>

          <v-divider></v-divider>
          <v-stepper-step
            :rules="[() => regStatus.step3]"
            step="3"
            :complete="regStatus.step3"
          >
            آدرس
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :rules="[() => regStatus.step4]"
            step="4"
            :complete="regStatus.step4"
          >
            حوزه فعالیت
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :rules="[() => regStatus.step5]"
            step="5"
            :complete="regStatus.step5"
          >
            لوگو و تصاویر
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step
            :rules="[() => regStatus.step6]"
            step="6"
            :complete="regStatus.step6"
          >
            معرفی کسب و کار
          </v-stepper-step>
        </v-stepper-header>
      </v-stepper>
      <!-- </v-card> -->
    </v-row>
    <v-row
      v-if="
        userBusinessInformation && userBusinessInformation.status != 'Approved'
      "
    >
      <!-- <v-col cols="12" md="10" sm="6">
        <div class="d-flex flex-row">
          <h5 v-if="!merchantRolesIsSupplier" class="blue--text ml-1 mr-1">
            {{ $store.getters.infomessageForBuyerİnTempSPanel }}
          </h5>
          <h5 v-if="merchantRolesIsSupplier" class="blue--text ml-1 mr-1">
            {{ $store.getters.infoMessageForSupplierInTempSPanel }}
          </h5>
          
        </div>
      </v-col> -->
      <v-col
        cols="12"
        md="2"
        sm="11"
        :class="
          $vuetify.breakpoint.mdAndUp ? 'd-flex justify-space-between' : ''
        "
      >
        <v-btn
          color="primary"
          :class="$vuetify.breakpoint.mdAndUp ? 'm-1 float-left' : ''"
          @click="gotoEditInformation()"
          block
        >
          {{
            readyTosendToConfirm
              ? 'ویرایش'
              : isSendToConfirm
              ? 'ویرایش'
              : 'تکمیل اطلاعات کسب و کار'
          }}
          <v-icon right dark> mdi-pencil </v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" md="1" sm="1">
        <HelperComponent helperId="business-general-info-help" class="mr-5" />
      </v-col>

      <v-col cols="12" md="9" sm="11">
        <v-alert dense text type="success" v-if="isSendToConfirm">
          <strong> صنعتگر محترم</strong> اطلاعات کسب و کار شما توسط ادمین در
          <strong>حال بررسی</strong>
          است. به محض تائید، مراتب انتشار از طریق
          <strong>پیامک </strong> اطلاع رسانی خواهد شد.
        </v-alert>

        <transition v-if="merchantRolesIsSupplier" name="fade">
          <v-btn
            color="light-green accent-3"
            v-if="readyTosendToConfirm"
            @click="sendRequestForConfirmation()"
            :block="$vuetify.breakpoint.smAndDown"
            :disabled="!regDataIsComplte"
          >
            ارسال جهت تایید و انتشار
          </v-btn>
        </transition>
      </v-col>
    </v-row>
    <v-row
      v-else-if="
        userBusinessInformation && userBusinessInformation.status == 'Approved'
      "
      class="mb-3"
    >
      <v-spacer></v-spacer>
      <div class="d-flex flex-row">
        <HelperComponent helperId="How-to-request-edit-merchant" class="mt-1" />
        <v-btn
          color="blue"
          class="mx-1 white--text"
          @click="gotoEditMerchant()"
        >
          درخواست ویرایش
          <v-icon right dark> mdi-pencil</v-icon>
        </v-btn>
      </div>
    </v-row>
    <business-information-user-info
      :userBusinessInformation="userBusinessInformation"
    ></business-information-user-info>
    <business-information-company-info
      :userBusinessInformation="userBusinessInformation"
    ></business-information-company-info>
    <business-information-address-info
      :userBusinessInformation="userBusinessInformation"
    ></business-information-address-info>
    <business-information-category
      v-if="merchantRolesIsSupplier"
      :merchantCategoriesBreadCrumbList="merchantCategoriesBreadCrumbList"
    ></business-information-category>
    <business-information-other-info
      :userBusinessInformation="userBusinessInformation"
    ></business-information-other-info>
    <template>
  <v-btn
      color="primary"
      :class="$vuetify.breakpoint.mdAndUp ? 'm-1 float-left' : ''"
      @click="gotoEditInformation()"
      :block="$vuetify.breakpoint.smAndDown"
    >
      {{
        readyTosendToConfirm
          ? 'ویرایش'
          : isSendToConfirm
          ? 'ویرایش'
          : 'تکمیل اطلاعات کسب و کار'
      }}
      <v-icon right dark> mdi-pencil </v-icon>
    </v-btn>
    <transition v-if="merchantRolesIsSupplier" name="fade">
      <v-btn
        color="light-green accent-3"
        v-if="readyTosendToConfirm"
        class="m-1 float-left"
        @click="sendRequestForConfirmation()"
        :block="$vuetify.breakpoint.smAndDown"
        :disabled="!regDataIsComplte"
      >
        ارسال جهت تایید و انتشار
      </v-btn>
    </transition>
    <!-- <div>
      <v-dialog v-model="showFinalInfoDialog"  max-width="550">
      <v-card>
        <v-toolbar color="indigo" dark>
          <div class="d-flex justify-space-between align-center w--100">
            <span class="white--text font-weight-bold">
              با سپاس از ثبت نام موفق شما در تکصان
            </span>
            <div class="font-s">
                <v-icon class="mdi mdi-timer"></v-icon>
            </div>
          </div>
        </v-toolbar>
        <v-card-text>
          <div class="d-flex flex-column justify-start align-start pa-2 my-2">
            <h4 class="h4">
              تامین کننده گرامی، شما در حال
              <strong>انتقال به پنل موقت</strong> هستید تا اطلاعات خود را تکمیل
              کرده و به ادمین تکصان ارسال کنید .
            </h4>

            <h4 class="h4">در این پنل شما به موارد زیر دسترسی دارید:</h4>

            <ul>
              <li>بازنگری و تکمیل حوزه فعالیت</li>
              <li>تکمیل اطلاعات بیشتری از کسب و کار</li>
              <li>مشاهده و ویرایش اطلاعات ثبت شده در در صورت نیاز</li>
              <li>
                پس از تکمیل اطلاعات، از طریق لینک
                <strong> ارسال جهت تایید و انتشار</strong>
                آنرا به ادمین ارسال کنید.
              </li>

              <li>
                امکان ارسال و دریافت پیام با پشتیبان سایت در خصوص موضوعات مختلف
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn
            color="orange accent-4"
            class="white--text"
            @click="showFinalInfoDialog=false"
            ><span>متوجه شدم </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div> -->
    </template>
  
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { RepoFactory } from '@/baseRepository/Factory';
const categoryRepository = () => RepoFactory.get('category');
const merchantRepository = () => RepoFactory.get('merchant');
import Helper from '@/core/helpers';
import Swal from 'sweetalert2';
import BusinessInformationUserInfo from '@/components/businessInformation/showDetail/BusinessInformationUserInfo.vue';
import BusinessInformationCompanyInfo from '@/components/businessInformation/showDetail/BusinessInformationCompanyInfo.vue';
import BusinessInformationAddressInfo from '@/components/businessInformation/showDetail/BusinessInformationAddressInfo.vue';
import BusinessInformationOtherInfo from '@/components/businessInformation/showDetail/BusinessInformationOtherInfo.vue';
import BusinessInformationCategory from '@/components/businessInformation/showDetail/BusinessInformationCategory.vue';
export default {
  components: {
    BusinessInformationUserInfo,
    BusinessInformationCompanyInfo,
    BusinessInformationAddressInfo,
    BusinessInformationOtherInfo,
    BusinessInformationCategory,
  },
  data() {
    return {
      //readyTosendToConfirm: false,
      showFinalInfoDialog: false,
      editStep: 1,
      userBusinessInformation: null,
      merchantCategoriesBreadCrumbList: [],
      regStatus: {
        step1: false, // manager info
        step2: false, // merchat company type
        step3: false, //address
        step4: false, // categories
        step5: false, // logo images
        step6: false, //about
      },
      regDataIsComplte: false,
    };
  },
  computed: {
    ...mapGetters([
      'authorize',
      'currentMerchant',
      'productBaseUrl',
      'merchantBaseUrl',
    ]),
    merchantRolesIsSupplier() {
      return this.$store.getters.userBusinessInformation?.isSupplier;
    },
    readyTosendToConfirm() {
      let isReady = false;
      isReady =
        this.userBusinessInformation &&
        (this.userBusinessInformation.status == 'Draft' ||
          this.userBusinessInformation.status == 'Rejected') &&
        this.merchantCategoriesBreadCrumbList.length > 0 &&
        this.regDataIsComplte;
      return isReady;
    },
    isSendToConfirm() {
      let isReady = false;
      isReady =
        this.userBusinessInformation &&
        this.userBusinessInformation.status == 'InProgress';
     
      return isReady;
    },
  },
  created() {
    if (
      this.authorize == 'merchant' &&
      !this.$store.getters.userDetails.roles.includes('supplier')
    ) {
      this.getSupplierInformation();
    } else {
      if (this.currentMerchant) {
        this.getMerchantInformation();
      }
    }
    
  },
 
  watch: {
    currentMerchant(after) {
      if (after) {
        this.getMerchantInformation();
      }
    },
    
  },

  methods: {
    // checkIsReadyToSendToConfirm() {
    //   let isReady = false;
    //   isReady =
    //     this.userBusinessInformation &&
    //     (this.userBusinessInformation.status == 'Draft' ||
    //       this.userBusinessInformation.status == 'Rejected') &&
    //     this.merchantCategoriesBreadCrumbList.length;
    //   this.readyTosendToConfirm = isReady;
    // },
    gotoEditMerchant() {
      this.$router.push(
        `/merchant-companies/${this.userBusinessInformation.merchantId}/edit`
      );
    },
    getSupplierInformation() {
      const loader = this.$loading.show();
      this.$store
        .dispatch('getSupplierInformation')
        .then((data) => {
          this.userBusinessInformation = data;
          this.getMerchantCategoriesBreadCrumb();
          this.CheckRegStatuse(data);
          setTimeout(() => {
            if (this.regDataIsComplte == false) {
              this.$router.push(`/business-information/edit/${this.editStep}`);
            }
          }, 100);
          // this.checkIsReadyToSendToConfirm()
        })
        .finally(() => {
          loader.hide();
        });
    },
    getMerchantInformation() {
      const loader = this.$loading.show();
      this.$store
        .dispatch('getMerchantInformation')
        .then((data) => {
          this.userBusinessInformation = data;
          this.CheckRegStatuse(data);
          this.getMerchantCategoriesBreadCrumb();
          //this.checkIsReadyToSendToConfirm()
        })
        .finally(() => {
          loader.hide();
        });
    },
    getMerchantCategoriesBreadCrumb() {
      const loader = this.$loading.show();
      categoryRepository()
        .getMerchantCategoriesBreadCrumb(this.productBaseUrl, {
          merchantId: this.userBusinessInformation.merchantId,
        })
        .then(({ data }) => {
          this.merchantCategoriesBreadCrumbList = data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
    gotoEditInformation() {
      this.$router.push(`/business-information/edit/${this.editStep}`);
    },
    sendRequestForConfirmation() {
      if (!this.regDataIsComplte) {
        Swal.fire({
          icon: 'warnin',
          title:
            ' قبل از ارسال اطلاعات آنرا کامل کنید. به راهنمای وضعیت اطلاعات توجه فرمایید  ',
          confirmButtonText: ' بستن',
        });
        return;
      }
      const loader = this.$loading.show();
      merchantRepository()
        .merchantRequestConfirmation(
          this.userBusinessInformation.merchantId,
          this.merchantBaseUrl
        )
        .then(() => {
          this.userBusinessInformation.status = 'InProgress';
          Swal.fire({
            icon: 'success',
            title:
              'ارسال درخواست با موفقیت انجام شد نتیجه به اطلاع شما خواهد رسید',
            confirmButtonText: ' بستن',
          });
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
      // Swal.fire({
      //   html: `اطلاعات شما جهت تایید به پشتیبانی ارسال میشود`,
      //   icon: 'warning',
      //   confirmButtonText: ' بلی',
      //   showCancelButton: true,
      //   cancelButtonText: 'خیر',
      //   reverseButtons: true,
      // }).then((result) => {
      //   if (result.value) {
      //     const loader = this.$loading.show();
      //     merchantRepository()
      //       .merchantRequestConfirmation(
      //         this.userBusinessInformation.merchantId,
      //         this.merchantBaseUrl
      //       )
      //       .then(() => {
      //         this.userBusinessInformation.status = 'InProgress';
      //         Swal.fire({
      //           icon: 'success',
      //           title:
      //             'ارسال درخواست با موفقیت انجام شد نتیجه به اطلاع شما خواهد رسید',
      //           confirmButtonText: ' بستن',
      //         });
      //       })
      //       .catch((error) => {
      //         Helper.handleErrors(error, this);
      //       })
      //       .finally(() => loader.hide());
      //   }
      // });

    },
    CheckRegStatuse(merchant) {
      // step1: true,// manager info
      // step2: true,// merchat company type
      // step3: false,//address
      // step4: true,// categories
      // step5: false,//  logo images
      // step6: false,//  about
      //console.log("merchant data is ", merchant)
     
      //if (merchant.status == 'InProgress') {
         //  this.showFinalInfoDialog = true;
      //}
    
      if (
        merchant.managerPerson != null &&
        merchant.managerPerson.mobile.length != 10
      ) {
        this.regStatus.step1 = true;
      }
      if (merchant.company != null && merchant.company.companyType) {
        this.regStatus.step2 = true;
      }
      if (merchant.address != null && merchant.address.cityId) {
        this.regStatus.step3 = true;
      }
      if (
        merchant.merchantCategories != null &&
        merchant.merchantCategories.length > 0
      ) {
        this.regStatus.step4 = true;
      }
      if (merchant.logo != null && merchant.images.length > 0) {
        this.regStatus.step5 = true;
      }
      if (merchant.about != null && merchant.about.length > 60) {
        this.regStatus.step6 = true;
      }
      if (
        this.regStatus.step1 &&
        this.regStatus.step2 &&
        this.regStatus.step3 &&
        this.regStatus.step4 &&
        this.regStatus.step5 &&
        this.regStatus.step6
      ) {
        this.regDataIsComplte = true;
      } else {
        this.regDataIsComplte = false;
      }
      //check this.editStep value Start
      if (
        this.regStatus.step1 &&
        !this.regStatus.step2 &&
        !this.regStatus.step3 &&
        !this.regStatus.step4 &&
        !this.regStatus.step5 &&
        !this.regStatus.step6
      ) {
        this.editStep = 2;
      }

      if (
        this.regStatus.step1 &&
        this.regStatus.step2 &&
        this.regStatus.step3 &&
        this.regStatus.step4 &&
        !this.regStatus.step5 &&
        !this.regStatus.step6
      ) {
        this.editStep = 5;
      }
    },
  },
};
</script>

<style></style>
